import { createContext, useContext } from 'react';

import { type ILoginResponse } from '../stores';

interface IAuthorizationContext {
  state: {
    user: ILoginResponse;
  };
  dispatch: {
    logout: () => Promise<void>;
  };
}

export const AuthorizationContext = createContext<IAuthorizationContext | undefined>(undefined);

export const useAuthorizationContext = () => {
  const context = useContext(AuthorizationContext);

  if (context === undefined) {
    throw new Error('useAuthorizationContext must be used within a AuthorizationContextProvider');
  }

  return context;
};
